import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import { isQA } from '../constants/apiEnvironments';
import { getIntegrationOrFlowKey } from '../routing/getIntegrationOrFlowKey';
const Batch1 = [Flow.Integrations, Flow.ClassroomTraining, Integration.Wpforms, Flow.FbCrm, Flow.AssetProvider, Flow.SolutionsProvider, Flow.Connect];
const Batch2 = [Flow.HubSpotPartners, Flow.HubspotForNonprofits, Flow.Purchase];
const Batch3 = [Flow.DirectoryListing, Flow.CmsDevelopers, Flow.HubspotForStartups, Flow.Service];
const Batch4 = [Flow.Developers, Flow.CmsFree, Integration.Wordpress, Flow.Sales, Flow.Marketing];
const Batch5 = [Flow.Academy, Flow.Crm, Flow.Trial];
export const shouldUseBEToSubmitAmplitudeEvent = () => {
  const flowKey = getIntegrationOrFlowKey();
  return isQA || Batch1.includes(flowKey) || Batch2.includes(flowKey) || Batch3.includes(flowKey) || Batch4.includes(flowKey) || Batch5.includes(flowKey);
};